import { CheckCircle, BookOpen, Wrench, Users, MessageSquare, TrendingUp } from "lucide-react";

const benefits = [
  {
    icon: BookOpen,
    title: "Claridad sobre la ruta",
    description: "Entiende qué vas a recibir, cómo está organizado el contenido y qué puedes esperar del proceso.",
  },
  {
    icon: TrendingUp,
    title: "Contenido organizado",
    description: "Accede a una propuesta educativa estructurada por módulos, provista por MINED.",
  },
  {
    icon: Wrench,
    title: "Herramientas complementarias",
    description: "Recursos de apoyo para validación, análisis y operación de tu proyecto de ecommerce.",
  },
  {
    icon: Users,
    title: "Entorno de aprendizaje",
    description: "Comunidad y contexto para avanzar con mayor continuidad y conexión.",
  },
  {
    icon: MessageSquare,
    title: "Orientación comercial por DSA",
    description: "Acompañamiento para entender la propuesta y evaluar si encaja contigo.",
  },
  {
    icon: CheckCircle,
    title: "Seguimiento y continuidad",
    description: "Contacto y seguimiento durante tu proceso de evaluación y decisión.",
  },
];

export default function BenefitsSection() {
  return (
    <section
      data-testid="benefits-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-4 block">
            Propuesta de valor
          </span>
          <h2
            className="text-3xl md:text-5xl font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Qué recibes al avanzar
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            Esto no es solo comprar contenido aislado. Es acceder a una propuesta educativa 
            más organizada, con recursos y contexto, y con una orientación comercial seria desde DSA.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              data-testid={`benefit-item-${index}`}
              className="group p-8 bg-gray-50/50 border border-gray-100 hover:bg-white hover:shadow-lg hover:border-[#0F3D56]/20 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#0F3D56]/10 flex items-center justify-center mb-6 group-hover:bg-[#0F3D56] transition-colors duration-300">
                <benefit.icon size={26} className="text-[#0F3D56] group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-lg font-bold text-[#111827] mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Clarification Note */}
        <div className="mt-16 max-w-3xl mx-auto text-center">
          <div className="bg-[#0F3D56]/5 border border-[#0F3D56]/10 p-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              <span className="font-semibold text-[#0F3D56]">Importante:</span> DSA no dicta el programa. 
              DSA orienta, filtra y acompaña en el proceso de evaluación. El contenido educativo 
              es provisto por MINED.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
